import React, { useEffect, useState } from 'react';

import { DataGrid, Column, Editing, type DataGridTypes, Lookup } from 'devextreme-react/data-grid';
import { RowInsertingEvent, RowRemovingEvent } from 'devextreme/ui/data_grid';

import PathType from '../../consts/pathmodule/PathType';

import PathApi from '../../api/PathApi';
import ReportingGroupApi from '../../api/ReportingGroupApi';

import PathListDto from '../../classes/dtos/pathmodule/PathListDto';
import ReportingGroupPathDto from '../../classes/dtos/reportinggroupmodule/ReportingGroupPathDto';

interface ReportingGroupPathTemplateProps extends DataGridTypes.MasterDetailTemplateData {
    refresh: () => void;
}

const ReportingGroupPathTemplate = (props: ReportingGroupPathTemplateProps) => {
    const { ReportingGroupPaths } = props.data.data;

    const [paths, setPaths] = useState<PathListDto[] | null>(null);

    useEffect(() => {
        PathApi.GetPathsAsync(PathType.Reporting).then((e) => {
            let allPaths = e.Result
                .toSorted((a, b) => (a.Name.toLowerCase() > b.Name.toLowerCase()) ? 1 : (a.Name.toLowerCase() < b.Name.toLowerCase()) ? -1 : 0);
            setPaths(allPaths);
        });
    }, []);

    const handleOnEditorPreparing = (e: any) => {
        if (e.parentType === 'dataRow' && e.dataField === 'PathId') {
            e.editorOptions.dataSource = paths;
        }
    };

    const handleSourceFieldReferenceIdCalculateDisplayValue = (e: any) => {
        if (paths === null) {
            return;
        }
        let found = paths!.find((x) => x.Id === e.PathId) ?? null;
        return found?.Name ?? "";
    }

    const selectFieldCell = (cellData: DataGridTypes.ColumnCellTemplateData) => {
        if (cellData.value > 0) { return (<div>{cellData.displayValue}</div>); }
        return (<span>{cellData.value || <span style={{ color: "#aaa" }}>Select a path...</span>}</span>);
    };

    function insertRow(e: RowInsertingEvent<ReportingGroupPathDto, any>) {
        ReportingGroupApi.CreateReportingGroupPathAsync(props.data.key, e.data.PathId)
            .then((e) => {
                if (e.IsFailed()) {
                    alert("ERROR");
                }
                else {
                    props.refresh();
                }
            });
    }

    function removeRow(e: RowRemovingEvent<ReportingGroupPathDto, any>) {
        ReportingGroupApi.DeleteReportingGroupPathAsync(e.data.ReportingGroupPathId)
            .then((e) => {
                if (e.IsFailed()) {
                    alert("ERROR");
                }
                else {
                    props.refresh();
                }
            });
    }

    return (
        <React.Fragment>
            <DataGrid
                dataSource={ReportingGroupPaths}
                showBorders={true}
                columnAutoWidth={true}
                onEditorPreparing={handleOnEditorPreparing}
                onRowInserting={insertRow}
                onRowRemoving={removeRow}>
                <Editing
                    mode="row"
                    allowUpdating={false}
                    allowDeleting={true}
                    allowAdding={true}
                    texts={{ addRow: 'Attach a path' }} />
                <Column caption="Path" dataField="PathId" dataType="number" allowEditing={true} calculateDisplayValue={handleSourceFieldReferenceIdCalculateDisplayValue} cellRender={selectFieldCell} editorOptions={{ placeholder: "Select a path..." }}>
                    <Lookup
                        displayExpr="Name"
                        valueExpr="Id"
                    />
                </Column>
            </DataGrid>
        </React.Fragment>
    );
};

export default ReportingGroupPathTemplate;
